<template>
  <div class="pc-home">
    <header-nav></header-nav>
    <div class="content-one content">
      <div class="type-area content-one-box">
        <img
          :src="imgUrl + 'img/pc/content-one-title.png'"
          class="content-one-title"
          alt=""
        />
        <div class="content-one-btn">
          <div class="btn-android" id="pc-download" @click="download" v-show="!isIos()">
            <img :src="imgUrl + 'img/android-icon.png'" alt="" />
            Android下载
            <!-- <img
              @click.stop=""
              :src="imgUrl + 'img/pc/ios-icon.png'"
              alt=""
              v-if="url.indexOf('bd') === -1"
            /> -->
          </div>
          <div class="btn-pc" @click="iosDownload" data-agl-cvt="6" v-show="isIos()">
            <img :src="imgUrl + 'img/ios-icon.png'" alt="" />
            苹果版下载
          </div>
        </div>
        <div class="content-one-about">
          <swiper class="swiper-about" :options="swiperOptions">
            <swiper-slide
              class="swiper-slide"
              v-for="(item, index) in carouselArr"
              :key="index"
              :name="item.value"
            >
              <img :src="item.url" />
            </swiper-slide>
          </swiper>
          <img :src="imgUrl + 'img/pc/content-one-about.png'" alt="" />
        </div>
        <!-- <img :src="imgUrl+'img/pc/scroll-down.png'"
                     alt=""
                     class="scroll-down"
                     @click="scrolDown"> -->
        <!-- <div class="footer-box">
          开发者：广州易指网络科技有限公司 I 版本号3.1.7 I
          <a href="https://www.ldyunos.com/ldy/appPermissions.html">
            应用权限
          </a>
          I
          <a href="http://www.ldmnq.com/ldy/ld-yinsi.html">隐私政策</a>
        </div>
        <div class="footer-box footer-box-1">
          开发者：广州易指网络科技有限公司 I 版本号3.1.7 I
          <a href="https://www.ldyunos.com/ldy/appPermissions.html">
            应用权限
          </a>
          I
          <a href="http://www.ldmnq.com/ldy/ld-yinsi.html">隐私政策</a>
        </div> -->
      </div>
    </div>
    <div class="content-two content">
      <div class="type-area">
        <img
          class="content-two-1"
          :src="imgUrl + 'img/pc/content-one-1.png'"
          alt=""
        />
        <img
          class="content-two-2"
          :src="imgUrl + 'img/pc/content-one-2.png'"
          alt=""
        />
      </div>
    </div>
    <div class="content-thr content">
      <div class="type-area">
        <div class="content-thr-l">
          <h1>游戏火力全开</h1>
          <p>
            一台手机变多台，同时运行多个云手机 支持同屏预览，随时查看游戏进展
          </p>
        </div>
        <div class="content-thr-r">
          <img :src="imgUrl + 'img/pc/content-thr.png'" alt="" />
        </div>
      </div>
    </div>
    <div class="content-for content">
      <div class="type-area">
        <img :src="imgUrl + 'img/pc/content-for.png'" alt="" />
      </div>
    </div>
    <!-- <footer-nav></footer-nav> -->
  </div>
</template>

<script>
import HeaderNav from "@/views/pc/components/header-nav.vue";
import FooterNav from "@/views/pc/components/footer-nav.vue";
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
export default {
  name: "Home",
  components: {
    HeaderNav,
    FooterNav,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      carouselArr: [
        {
          value: "siide1",
          url: "https://res.ldmnq.com/ldq_website/img/pc/slider-3.png",
        },
        {
          value: "siide2",
          url: "https://res.ldmnq.com/ldq_website/img/pc/slider-2.png",
        },
        {
          value: "siide3",
          url: "https://res.ldmnq.com/ldq_website/img/pc/slider-1.png",
        },
        {
          value: "siide4",
          url: "https://res.ldmnq.com/ldq_website/img/pc/slider-4.png",
        },
      ],
      swiperOptions: {
        slidesPerView: "auto",
        spaceBetween: 0.5,
        centeredSlides: true,
        loop: true,
        autoplay: 2000,
        autoplayDisableOnInteraction: false,
        stopOnlastSlide: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      imgUrl: "https://res.ldmnq.com/ldq_website/",
      url: "",
    };
  },
  mounted() {
    this.url = location.href;
    this.url = this.url.split("?")[0];

    const from = this.getUrlParams('from')
    if(from.indexOf('zdjl')>=0){

    }else{
      window.location.href =  'https://www.ldyuncs.com'
    }


  },
  methods: {
  getUrlParams(key){
    const url = decodeURIComponent(window.location.href);
    const str = url.split('?')[1];
    const obj = {};
    if (str) {
      const keys = str.split('&');
      keys.forEach((item) => {
        const arr = item.split('=');
        obj[arr[0]] = arr[1];
      });
    }
    return key ? obj[key] : obj;
  },

    scrolDown() {
      const options = {
        left: 0,
        top: document.documentElement.clientHeight,
        behavior: "smooth",
      };
      window.scrollTo(options);
    },
    pcDownload() {
      window.location.href = 'https://lddl01.ldmnq.com/ldyun.exe?n=ldyun_15100_15168_ld.exe';
    },
    iosDownload() {
      window.location.href = 'https://t.ldmnq.com/ldysjzdwlios';
    },
    download() {
      const from = this.getUrlParams('from')
      if(from.indexOf('zdjl')>=0){
        window.location.href = 'https://t.ldmnq.com/ldysjzd';
      }else{
        window.location.href =  'https://www.ldyuncs.com'
      }
    },
    isIos(){
      var u = navigator.userAgent;
		  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    }
  },
};
</script>
<style lang="scss" scoped>
.pc-home {
  .content-one {
    // margin-top: 100px;
    background: url("https://res.ldmnq.com/ldq_website/img/pc/content-one-bg.png")
      no-repeat;
    // background-size: 100vh;
    background-size: cover;
    min-height: changeVw(920);
    height: changeVw(1080);
    max-height: 100vh;
    overflow: hidden;
    .footer-box {
      position: absolute;
      z-index: 999;
      color: red;
      top: changeVw(750);
      font-size: changeVw(18);
      display: flex;
      align-items: center;
      a {
        color: red;
        margin: 0 changeVw(5);
      }
      // left: 0;
    }
    .footer-box-1 {
      top: changeVw(150);
      right: changeVw(-84);
    }
    .content-one-box {
      // height: changeVw(1080);
      height: 100vh;
      position: relative;
    }
    .type-area > img {
      position: absolute;
    }
    .content-one-title {
      top: changeVw(290);
      left: -5vw;
      width: changeVw(600);
      // height: changeVw(210);
    }
    .content-one-about {
      position: absolute;
      top: changeVw(220);
      right: changeVw(-84);
      > img {
        width: changeVw(550);
        height: changeVw(704);
      }
    }
    .content-one-btn {
      position: absolute;
      top: changeVw(610);
      left: 0;
      display: flex;
      div {
        width: changeVw(280);
        height: changeVw(80);
        border-radius: changeVw(50);
        display: flex;
        align-items: center;
      }
      .btn-android {
        background: linear-gradient(180deg, #ffcc00 0%, #f4c51f 100%);
        cursor: pointer;
        font-size: changeVw(26);
        color: #000;
        padding-left: changeVw(31);
        margin-right: changeVw(40);
        position: relative;
        // img:nth-child(1) {
        //   width: changeVw(48);
        //   margin-right: changeVw(8);
        // }
        // img:nth-child(2) {
        //   display: none;
        //   position: absolute;
        //   bottom: changeVw(-220);
        //   left: 50%;
        //   transform: translate3d(-50%, 0, 0);
        //   width: changeVw(200);
        //   height: changeVw(200);
        // }
      }
      // .btn-android:hover img:nth-child(2) {
      //   display: block;
      // }
      .btn-pc {
        background: linear-gradient(180deg, #ffcc00 0%, #f4c51f 100%);
        border: changeVw(2) solid #333333;
        color: #000;
        // opacity: 0.4;
        font-size: changeVw(26);
        padding-left: changeVw(40);
        cursor: pointer;
        img {
          width: changeVw(32);
          margin-right: changeVw(17);
        }
      }
    }
    .scroll-down {
      bottom: changeVw(40);
      left: 50%;
      transform: translateX(-50%);
      cursor: pointer;
    }
  }
  .content-two {
    background: #fff;
    height: changeVw(760);
    > div {
      position: relative;
    }
    .type-area > img {
      position: absolute;
    }
    .content-two-1 {
      top: changeVw(155);
      left: 0;
      z-index: 1;
      width: changeVw(504);
    }
    .content-two-2 {
      top: changeVw(155);
      right: 0;
      width: changeVw(1029);
    }
  }
  .content-thr {
    background: linear-gradient(180deg, #22233c 0%, #151626 100%);
    overflow: hidden;
    height: changeVw(760);
    > div {
      display: flex;
      justify-content: space-between;
    }
    .content-thr-l {
      padding-top: changeVw(160);
      h1 {
        font-weight: normal;
        font-size: changeVw(60);
        color: #fff;
      }
      p {
        width: changeVw(520);
        font-weight: 290;
        font-size: changeVw(24);
        color: #fff;
        opacity: 0.8;
        margin-top: changeVw(70);
        line-height: changeVw(40);
      }
    }
    .content-thr-r {
      padding-top: changeVw(120);
      img {
        width: changeVw(680);
      }
    }
  }
  .content-for {
    background: #fff;
    height: changeVw(760);
    img {
      margin-top: changeVw(150);
      width: changeVw(1190);
    }
  }
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  transition: 300ms;
  transform: scale(0.8);
  > img {
    width: changeVw(252);
    height: changeVw(449);
  }
  width: changeVw(252) !important;
  // height: changeVw(449);
  margin-right: 0 !important;
}
.swiper-about {
  position: absolute;
  top: changeVw(95);
  left: changeVw(109);
  width: changeVw(332) !important;
  height: changeVw(449) !important;
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  // margin-left: 10px;
  transform: scale(1);
}
</style>
